import {
  AgendaCommercialeControllerApi,
  AgendaCommercialeDashboardDto,
  AgendaCommercialeDto,
  AgendaCommercialeFilterOptionsDto,
  GetAgendaCommercialeDashboardRequest,
  RptAgendaCommercialePagedDto,
  RptOpportunityPagedDto,
  AgendaCommercialeSearchDto,
  Configuration,
  DeleteAgendaCommercialeRequest,
  SaveOrUpdateAgendaCommercialeRequest,
  SearchAgendaCommercialeRequest,
  SearchOpportunityRequest,
} from '@api/client';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkApiConfig } from 'core/store';
import getConfiguration, { errorHandler } from 'core/store/config';

enum AgendaCommercialeActions {
  searchAgendaActions = '[AgendaCommerciale] Search Actions',
  saveOrUpdateAgendaAction = '[AgendaCommerciale] Save Or Update Action',
  deleteAgendaAction = '[AgendaCommerciale] Delete Action',
  saveFiltersUsed = '[AgendaCommerciale] Save Filters Used',
  loadOpportunitiesForModal = '[AgendaCommerciale] Load Opportunities For Modal',
  getAgendaFilterOptions = '[AgendaCommerciale] Get Filter Options',
  getAgendaDashboard = '[AgendaCommerciale] Get Dashboard',
}

export const getAgendaDashboard = createAsyncThunk<
  AgendaCommercialeDashboardDto | undefined,
  GetAgendaCommercialeDashboardRequest,
  ThunkApiConfig
>(AgendaCommercialeActions.getAgendaDashboard, async (payload, { dispatch, extra, getState }) => {
  try {
    return await new AgendaCommercialeControllerApi(
      getConfiguration(Configuration, extra, getState)
    ).getAgendaCommercialeDashboard(payload);
  } catch (e) {
    errorHandler(e, dispatch, getState);
  }
});

export const searchAgendaActions = createAsyncThunk<
  RptAgendaCommercialePagedDto | undefined,
  SearchAgendaCommercialeRequest,
  ThunkApiConfig
>(AgendaCommercialeActions.searchAgendaActions, async (payload, { dispatch, extra, getState }) => {
  try {
    return await new AgendaCommercialeControllerApi(
      getConfiguration(Configuration, extra, getState)
    ).searchAgendaCommerciale(payload);
  } catch (e) {
    errorHandler(e, dispatch, getState);
  }
});

export const saveOrUpdateAgendaAction = createAsyncThunk<
  AgendaCommercialeDto | undefined,
  SaveOrUpdateAgendaCommercialeRequest,
  ThunkApiConfig
>(AgendaCommercialeActions.saveOrUpdateAgendaAction, async (payload, { dispatch, extra, getState }) => {
  try {
    return await new AgendaCommercialeControllerApi(
      getConfiguration(Configuration, extra, getState)
    ).saveOrUpdateAgendaCommerciale(payload);
  } catch (e) {
    errorHandler(e, dispatch, getState);
  }
});

export const deleteAgendaAction = createAsyncThunk<void, DeleteAgendaCommercialeRequest, ThunkApiConfig>(
  AgendaCommercialeActions.deleteAgendaAction,
  async (payload, { dispatch, extra, getState }) => {
    try {
      await new AgendaCommercialeControllerApi(
        getConfiguration(Configuration, extra, getState)
      ).deleteAgendaCommerciale(payload);
    } catch (e) {
      errorHandler(e, dispatch, getState);
    }
  }
);

export const saveFiltersAgendaActionsUsed = createAction<AgendaCommercialeSearchDto>(
  AgendaCommercialeActions.saveFiltersUsed
);

export const getAgendaFilterOptions = createAsyncThunk<
  AgendaCommercialeFilterOptionsDto | undefined,
  void,
  ThunkApiConfig
>(AgendaCommercialeActions.getAgendaFilterOptions, async (_, { dispatch, extra, getState }) => {
  try {
    return await new AgendaCommercialeControllerApi(
      getConfiguration(Configuration, extra, getState)
    ).getAgendaCommercialeFilterOptions();
  } catch (e) {
    errorHandler(e, dispatch, getState);
  }
});

// Thunk dedicato: carica attività per opportunity senza toccare lo store principale
export const loadActivitiesForOpportunity = createAsyncThunk<
  RptAgendaCommercialePagedDto | undefined,
  SearchAgendaCommercialeRequest,
  ThunkApiConfig
>('[AgendaCommerciale] Load Activities For Opportunity', async (payload, { dispatch, extra, getState }) => {
  try {
    return await new AgendaCommercialeControllerApi(
      getConfiguration(Configuration, extra, getState)
    ).searchAgendaCommerciale(payload);
  } catch (e) {
    errorHandler(e, dispatch, getState);
  }
});

// Thunk dedicato al modale: carica opportunity senza toccare lo store
export const loadOpportunitiesForModal = createAsyncThunk<
  RptOpportunityPagedDto | undefined,
  SearchOpportunityRequest,
  ThunkApiConfig
>(AgendaCommercialeActions.loadOpportunitiesForModal, async (payload, { dispatch, extra, getState }) => {
  try {
    return await new AgendaCommercialeControllerApi(
      getConfiguration(Configuration, extra, getState)
    ).searchOpportunity(payload);
  } catch (e) {
    errorHandler(e, dispatch, getState);
  }
});
